import { isFeatureEnabled } from 'owa-feature-flags';
import { LazyModule } from 'owa-bundling';
import { runAfterInitialRender } from 'owa-delayed-initialization';
import { showNotificationOnMailboxQuotaWarning } from 'owa-mail-triage-action';

const lazySubscribeToMailNotifications = new LazyModule<any>(() =>
    import(/* webpackChunkName: "Notifications" */ './orchestrators/handleNewMailNotification')
);

runAfterInitialRender(() => {
    if (isFeatureEnabled('fwk-webNotification')) {
        lazySubscribeToMailNotifications.import();
    }
    showNotificationOnMailboxQuotaWarning();
});
